import { Injectable } from '@angular/core';

const LAST_URL: string = "lastUrl";

@Injectable()
export default class StorageUtils {
    constructor() { }

    static initialize() {
    }

    static get Storage(): Storage {
        return localStorage;
    }

    static get(key: string): string {
        return this.Storage.getItem(key);
    }

    static set(key: string, value: any): void {
        // check type of 'value' then do the necessary conversion to string before setItem
        this.Storage.setItem(key, value);
    }

    static remove(key: string): void {
        this.Storage.removeItem(key);
    }

    static getLastUrl(): string {
        return this.get(LAST_URL) || "";
    }

    static setLastUrl(value: string): void {
        this.set(LAST_URL, value);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utilities/storage.utils.ts